import types from './types';

const createReseter = (subtype) => (action) => {
  if (!action.error) {
    return null;
  }

  return (dispatch) => {
    setTimeout(() => {
      dispatch({
        type: types.USER_RESET_ERROR,
        payload: subtype,
      });
    }, 10000);
  };
};

export default {
  [types.LOGIN]: [createReseter('login')],
  [types.SIGNUP]: [createReseter('signup')],
  [types.RESET_PASSWORD]: [createReseter('passwordReset')],
};



// WEBPACK FOOTER //
// ./src/modules/user/reactions.js